module.exports = __webpack_public_path__ + "img/free.2e165006.png";